import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const contraGolpePreciso: TechniqueDefinition = {
  id: "contra_golpe_preciso",
  name: "Contra-Golpe Preciso",
  description:
    "Prepares an empowered physical counter after an eligible hit or a successful Reflex Defense. The strike uses the next available action.",
  family: "taijutsu",
  proficiency: "taijutsu",
  targeting: "reactive_counter",
  behavior: { kind: "counter" },
  reactive: {
    kind: "counter",
    readyWindowMs: 4_000,
    expiresOnNextAction: true,
  },
  levels: {
    1: {
      chakraCost: 16,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 10,
      attackCoefficient: 1.2,
      counterDamageBonus: 0.3,
    },
    2: {
      chakraCost: 16,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 11,
      attackCoefficient: 1.24,
      counterDamageBonus: 0.32,
    },
    3: {
      chakraCost: 17,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 12,
      attackCoefficient: 1.28,
      counterDamageBonus: 0.34,
    },
    4: {
      chakraCost: 17,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 13,
      attackCoefficient: 1.32,
      counterDamageBonus: 0.36,
    },
    5: {
      chakraCost: 18,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 14,
      attackCoefficient: 1.36,
      counterDamageBonus: 0.38,
    },
    6: {
      chakraCost: 18,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 15,
      attackCoefficient: 1.4,
      counterDamageBonus: 0.4,
    },
    7: {
      chakraCost: 19,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 16,
      attackCoefficient: 1.44,
      counterDamageBonus: 0.42,
    },
    8: {
      chakraCost: 20,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 17,
      attackCoefficient: 1.48,
      counterDamageBonus: 0.44,
    },
    9: {
      chakraCost: 21,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 18,
      attackCoefficient: 1.52,
      counterDamageBonus: 0.46,
    },
    10: {
      chakraCost: 22,
      cooldownMs: 8_000,
      range: 48,
      maxTargets: 1,
      power: 18,
      attackCoefficient: 1.55,
      counterDamageBonus: 0.48,
    },
  },
  visual: {
    effectId: 5,
    castEffectId: null,
    impactEffectId: 5,
  },
};
